import { combineReducers } from "redux";
import actions from "../constants/roHubAccessActions";
import {
  getFetchingState,
  getSuccessState,
  getErrorState,
  getResetState,
  createReducer,
} from "../utils/reducers";

const defaultState = {
  fetching: false,
  result: null,
  error: null,
};

const getRestrictedHubs = createReducer(defaultState, {
  [actions.GET_RESTRICTED_HUBS]: getFetchingState,
  [actions.GET_RESTRICTED_HUBS_SUCCESS]: getSuccessState,
  [actions.GET_RESTRICTED_HUBS_ERROR]: getErrorState,
  [actions.GET_RESTRICTED_HUBS_CLEAR]: getResetState,
});

export default combineReducers({
  getRestrictedHubs,
});
